import React, { ReactNode } from "react";
import { StyleWrapper } from "./style";

const Wrapper = ({
  children,
  stylewrapper,
}: {
  children: ReactNode;
  stylewrapper?: any;
}) => {
  return <StyleWrapper stylewrapper={stylewrapper}>{children}</StyleWrapper>;
};

export default Wrapper;
